import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FailedPaymentCard } from './FailedPaymentCard';
import { Carousel, CarouselItem } from '../Carousel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SECTION_HEIGHT = 290;
export function FailedPaymentsOverview({
  contactFirstName,
  failedPaymentGroups,
  loading
}) {
  const nonEmptyGroups = failedPaymentGroups.filter(group => group.failedPayments.length > 0);
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "failed-payments-section",
      style: {
        minHeight: SECTION_HEIGHT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        margin: "0",
        size: "extra-small"
      })
    });
  }
  if (nonEmptyGroups.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "failed-payments-section",
    style: {
      minHeight: SECTION_HEIGHT
    },
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-500",
        children: contactFirstName ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "failedPayments.greeting",
          options: {
            name: contactFirstName
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "failedPayments.greetingNoName"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "failedPayments.description",
          options: {
            count: nonEmptyGroups.length
          }
        })
      }), /*#__PURE__*/_jsx(Carousel, {
        "aria-label": "Failed payments",
        children: nonEmptyGroups.map(group => {
          var _group$invoiceId, _group$failedPayments;
          return /*#__PURE__*/_jsx(CarouselItem, {
            children: /*#__PURE__*/_jsx(FailedPaymentCard, {
              group: group
            })
          }, (_group$invoiceId = group.invoiceId) !== null && _group$invoiceId !== void 0 ? _group$invoiceId : (_group$failedPayments = group.failedPayments[0]) === null || _group$failedPayments === void 0 ? void 0 : _group$failedPayments.paymentId);
        })
      })]
    })
  });
}